import { CurrentlyOnTvTray } from '../../../domain/currently-on-tv-tray';
import {
  CreateCurrentlyOnTvPageItemRequestApiModel,
  CurrentlyOnTvItemApiModel,
  CurrentlyOnTvPageItemApiModel,
  UpdateCurrentlyOnTvPageItemRequestApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  layoutMapperDomainToApi,
  mapChannelDomainModelToApiModel,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  dthStatusMapper,
  layoutMapperApiToDomain,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { CurrentlyOnTvTrayFormViewModel } from './currently-on-tv-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  layoutMapper,
  mapChannelDomainModelToViewModel,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  mapChannelViewModelToDomainModel,
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'CurrentlyOnTvTray'

/**
 * DOMAIN -> API
 */

export const mapCurrentlyOnTVTrayDomainModelToApiModel = (
  item: CurrentlyOnTvTray,
  pageVersionId?: string,
  tenantId?: string
): CreateCurrentlyOnTvPageItemRequestApiModel & UpdateCurrentlyOnTvPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    layoutMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    items: item?.channels?.map(mapChannelDomainModelToApiModel),
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapCurrentlyOnTVTrayApiModelToDomainModel = (currentlyOnTv: CurrentlyOnTvPageItemApiModel): CurrentlyOnTvTray => {
  return remainderMapper(
    mapperPipe(
      currentlyOnTv,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperDomainToApi,
      layoutMapperApiToDomain,
      dthStatusMapper
    ),
    () => ({
      type: 'CurrentlyOnTvTray',
      channels: currentlyOnTv?.items?.map((it: CurrentlyOnTvItemApiModel) => ({
        id: it.id,
        order: it.order,
        channel: {
          id: it.channel.id,
          channelID: it.channel.channelId,
          channelName: it.channel.channelName,
          channelNumber: it.channel.channelNumber,
        },
      })),
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapCurrentlyOnTvTrayDomainModelToViewModel = (value: CurrentlyOnTvTray): CurrentlyOnTvTrayFormViewModel => {
  const commonProperties = mapperPipe(
    value,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.CurrentlyOnTvTray, // AXB-73
    channels: value.channels?.map(mapChannelDomainModelToViewModel).sort((a, b) => a.order - b.order),
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapCurrentlyOnTvTrayViewModelToDomainModel = (vm: CurrentlyOnTvTrayFormViewModel): CurrentlyOnTvTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper,
    layoutMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'CurrentlyOnTvTray', // AXB-73
    channels: vm.channels.map(mapChannelViewModelToDomainModel),
  }));
};
